import React from 'react';

export default function ThemeBackground() {
  return (
    <>
      <style>{`
        @keyframes blobDrift1 {
          from { transform: translate(0px,    0px)  scale(1);    }
          to   { transform: translate(45px,  -35px) scale(1.06); }
        }
        @keyframes blobDrift2 {
          from { transform: translate(0px,   0px)  scale(1);    }
          to   { transform: translate(-35px, 45px) scale(0.94); }
        }
        @keyframes blobDrift3 {
          from { transform: translate(0px,   0px)  scale(1);    }
          to   { transform: translate(25px,  35px) scale(1.09); }
        }
        @keyframes blobDrift4 {
          from { transform: translate(0px,    0px)  scale(1);    }
          to   { transform: translate(-45px, -25px) scale(0.96); }
        }
        @keyframes blobDrift5 {
          from { transform: translate(0px,   0px)  scale(1);    }
          to   { transform: translate(15px, -20px) scale(1.03); }
        }

        /* -- dark theme (default) ---------------------------------------- */
        .theme-blob-1 {
          background: radial-gradient(circle, rgba(255,78,138,0.38) 0%, rgba(255,78,138,0.15) 45%, transparent 70%);
          animation: blobDrift1 18s cubic-bezier(0.45,0.05,0.55,0.95) infinite alternate;
          will-change: transform;
        }
        .theme-blob-2 {
          background: radial-gradient(circle, rgba(255,140,105,0.26) 0%, rgba(255,140,105,0.10) 45%, transparent 70%);
          animation: blobDrift2 15s cubic-bezier(0.45,0.05,0.55,0.95) infinite alternate;
          animation-delay: -5s;
          will-change: transform;
        }
        .theme-blob-3 {
          background: radial-gradient(circle, rgba(100,60,200,0.30) 0%, rgba(100,60,200,0.12) 45%, transparent 70%);
          animation: blobDrift3 21s cubic-bezier(0.45,0.05,0.55,0.95) infinite alternate;
          animation-delay: -10s;
          will-change: transform;
        }
        .theme-blob-4 {
          background: radial-gradient(circle, rgba(200,50,100,0.22) 0%, rgba(200,50,100,0.08) 45%, transparent 70%);
          animation: blobDrift4 17s cubic-bezier(0.45,0.05,0.55,0.95) infinite alternate;
          animation-delay: -7s;
          will-change: transform;
        }
        .theme-blob-5 {
          background: radial-gradient(circle, rgba(130,40,180,0.16) 0%, rgba(130,40,180,0.06) 45%, transparent 65%);
          animation: blobDrift5 26s cubic-bezier(0.45,0.05,0.55,0.95) infinite alternate;
          animation-delay: -3s;
          will-change: transform;
        }

        /* -- light theme overrides ---------------------------------------- */
        [data-theme="light"] .theme-blob-1 {
          background: radial-gradient(circle, rgba(255,78,138,0.22) 0%, rgba(255,78,138,0.08) 45%, transparent 70%);
        }
        [data-theme="light"] .theme-blob-2 {
          background: radial-gradient(circle, rgba(255,140,105,0.18) 0%, rgba(255,140,105,0.06) 45%, transparent 70%);
        }
        [data-theme="light"] .theme-blob-3 {
          background: radial-gradient(circle, rgba(160,100,230,0.20) 0%, rgba(160,100,230,0.07) 45%, transparent 70%);
        }
        [data-theme="light"] .theme-blob-4 {
          background: radial-gradient(circle, rgba(255,78,138,0.14) 0%, rgba(255,78,138,0.05) 45%, transparent 70%);
        }
        [data-theme="light"] .theme-blob-5 {
          background: radial-gradient(circle, rgba(200,100,150,0.12) 0%, rgba(200,100,150,0.04) 45%, transparent 65%);
        }
      `}</style>

      <div style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}>
        <div className="theme-blob-1" style={{
          position: 'absolute',
          width: '520px', height: '520px',
          top: '-120px', left: '-120px',
          borderRadius: '50%',
        }} />
        <div className="theme-blob-2" style={{
          position: 'absolute',
          width: '420px', height: '420px',
          top: '-60px', right: '-60px',
          borderRadius: '50%',
        }} />
        <div className="theme-blob-3" style={{
          position: 'absolute',
          width: '380px', height: '380px',
          bottom: '-90px', left: 'calc(50% - 190px)',
          borderRadius: '50%',
        }} />
        <div className="theme-blob-4" style={{
          position: 'absolute',
          width: '460px', height: '460px',
          top: '35%', left: '-100px',
          borderRadius: '50%',
        }} />
        <div className="theme-blob-5" style={{
          position: 'absolute',
          width: '700px', height: '700px',
          top: 'calc(50% - 350px)', left: 'calc(50% - 350px)',
          borderRadius: '50%',
        }} />
      </div>
    </>
  );
}
